import _ from 'lodash';
import AmpersandCollection from 'ampersand-collection';
import NoteTypeModel from './note-type-model';

const NoteTypeCollection = AmpersandCollection.extend({

    model: NoteTypeModel,
    comparator: "sortPosition",

    filterByCompany(companyId) {
        return new NoteTypeCollection(this.filter(m=>m.companyId === companyId && !m.isDeleted)).sort();
    },

    resetAndMarkOldModelsAsDeleted(data, companyId) {
        const previousCollectionModels = _.clone(this.models)

        if (companyId) {
            this.resetByCompany(companyId, data)
        } else {
            this.reset(data, {parse:true})
        }

        // add models that are missing in new session Collection
        _.map(previousCollectionModels, model => {
            if (!this.get(model.id)) {
                model.isDeleted = true
                this.add(model)
            }
        })
    },

    resetByCompany(companyId,newData) {
        const oldTasks = this.filter(taskType=>taskType.companyId === companyId);

        _.each(oldTasks,model=>{
            this.remove(model,{ silent: true });
        });

        this.add(newData,{parse:true});
    },

});

module.exports = NoteTypeCollection;